module.exports = __webpack_public_path__ + "static/media/Apocalypse Swamp Creature.d0c79abf.jpg";